import {
  Box,
  Button,
  FormControl,
  InputLabel,
  Link,
  MenuItem,
  Modal,
  TextField,
} from "@mui/material";
import LinearProgress, {
  linearProgressClasses,
} from "@mui/material/LinearProgress";
import Select, { SelectChangeEvent } from "@mui/material/Select";
import Grid from "@mui/material/Unstable_Grid2";
import { styled } from "@mui/material/styles";
import React, { useCallback, useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import AddNewEmployee from "../../../../Components/Broker/Employee/AddNewEmployeeSP/AddNewEmployee";
import BulkUploadForm from "../../../../Components/Common/BulkUploadFormSP/BulkUploadForm";
import RKTextField from "../../../../Supporting files/RKTextField/RKTextField";
import UGTable from "../../../../Supporting files/UGTable/UGTable";
// import AddNewEmployee from "../../../../Components/Broker/Employee/AddNewEmployee/AddNewEmployee";
import { ALL_ROUTES } from "../../../../Routes/all_routes";
import UGDateRangePicker from "../../../../Supporting files/UGDateRangePicker/UGDateRangePicker";
import SearchBox from "../../../../Components/Broker/SearchBarAnimation/SearchBox";

interface Props {
  addEmployee: boolean;
}

const Employees: React.FC<Props> = ({ addEmployee }) => {
  const [addFilterStatus, setAddFilterStatus] = React.useState(false);
  const [removeEmployee, setRemoveEmployee] = React.useState(false);
  const [InviteEmployee, setInviteEmployee] = React.useState(false);
  const [addNewEmployee, setAddNewEmployee] = React.useState(addEmployee);
  const [uploadFile, setUploadFile] = React.useState(false);
  const [uploadFileStep, setUploadFileStep] = React.useState(1);
  const [addPolicyStatus, setAddPolicyStatus] = React.useState(false);
  const [policyType, setPolicyType] = React.useState("");
  const [policyname, setPolicyName] = React.useState("");
  const [expiry, setExpiryStatus] = React.useState("");
  const [age, setAge] = React.useState("");
  const [emailAddress, setEmailAddress] = React.useState("");
  // new variables
  const [gender, setGender] = React.useState("");
  const navigate = useNavigate();
  useEffect(() => {
    // attach the event listener
    window.addEventListener("keydown", handleKeyPress);
  }, []);

  const handleKeyPress = useCallback((e: any) => {
    var event = e;
    if (event.target.tagName !== "INPUT") {
      if (event.shiftKey && event.keyCode == 69) {
        setAddNewEmployee(true);
      }
    }
  }, []);

  const handleChange = (event: SelectChangeEvent, attrName: string) => {
    if (attrName === "gender") {
      setGender(event.target.value as string);
    } else if (attrName === "policyType") {
      setPolicyType(event.target.value as string);
    } else if (attrName === "expiry") {
      setExpiryStatus(event.target.value as string);
    } else if (attrName === "policyname") {
      setPolicyName(event.target.value as string);
    } else if (attrName === "age") {
      setAge(event.target.value as string);
    }
  };

  //Table Data
  const [columns, setColumns] = React.useState([
    {
      field: "member_type",
      headerName: "Member Type",
      width: 150,
      check_status: true,
    },
    {
      field: "employee_id",
      headerName: "Member ID",
      width: 150,
      check_status: true,
    },
    {
      field: "client_id",
      headerName: "Client ID",
      width: 150,
      check_status: true,
    },

    // {
    //   field: "title",
    //   headerName: "Title",
    //   width: 100,
    //   check_status: true,
    // },
    {
      field: "fullName",
      headerName: "First Name",
      width: 200,
      check_status: true,
      renderCell: (ValueFormatterParams: any) => {
        const { row } = ValueFormatterParams;
        return (
          <Link
            underline="none"
            style={{
              cursor: "pointer",
              fontWeight: "400",
              color: "#2166AA",
              textDecoration: "none",
            }}
            onClick={() => {
              navigate(
                row.member_type === "Dependant"
                  ? "/EmployeeDetails?type=dependant"
                  : "/EmployeeDetails?type=employee"
              );
            }}
          >
            {row.fullName}
          </Link>
        );
      },
    },
    {
      field: "last_name",
      headerName: "Last Name",
      width: 200,
      check_status: true,
    },
    {
      field: "org_employee",
      headerName: "Organisation Employee Id",
      width: 200,
      check_status: true,
    },
    {
      field: "relationship_emp",
      headerName: "Relationship With Employee",
      width: 200,
      check_status: true,
    },
    {
      field: "related_emp",
      headerName: "Primary Employee",
      width: 200,
      check_status: true,
    },
    {
      field: "gender",
      headerName: "Gender",
      width: 150,
      check_status: true,
    },
    {
      field: "personal_email",
      headerName: "Personal Email",
      width: 200,
      check_status: true,
      renderCell: (ValueFormatterParams: any) => {
        const { row } = ValueFormatterParams;
        return (
          <Link
            href={row.personal_email}
            target="_blank"
            style={{ textDecoration: "none" }}
          >
            {row.personal_email}
          </Link>
        );
      },
    },
    {
      field: "company_email",
      headerName: "Company Email",
      width: 200,
      check_status: true,
      renderCell: (ValueFormatterParams: any) => {
        const { row } = ValueFormatterParams;
        return (
          <Link
            href={row.company_email}
            target="_blank"
            style={{ textDecoration: "none" }}
          >
            {row.company_email}
          </Link>
        );
      },
    },
    {
      field: "mobile",
      headerName: "Mobile",
      width: 150,
      check_status: true,
    },
    {
      field: "dob",
      headerName: "DOB",
      width: 150,
      check_status: true,
    },
    {
      field: "doj",
      headerName: "Date of Joining",
      width: 130,
      check_status: true,
    },
    {
      field: "department",
      headerName: "Department",
      width: 160,
      check_status: true,
    },
    {
      field: "designation",
      headerName: "Designation",
      width: 160,
      check_status: true,
    },
    {
      field: "salary",
      headerName: "Salary",
      width: 200,
      check_status: true,
    },
    {
      field: "salary_bracket",
      headerName: "Salary Bracket",
      width: 200,
      check_status: true,
    },

    {
      field: "status",
      headerName: "Status",
      width: 130,
      check_status: true,
      renderCell: (ValueFormatterParams: any) => {
        const { row } = ValueFormatterParams;
        return <span className={row.status}>{row.status}</span>;
      },
    },
    // {
    //   field: "dependents",
    //   headerName: "Dependent",
    //   width: 100,
    //   check_status: true,
    // },
    // {
    //   field: "nod",
    //   headerName: "No. of Dependents",
    //   width: 130,
    //   check_status: true,
    // },
    {
      field: "hno",
      headerName: "H.No. / Building",
      width: 130,
      check_status: true,
    },
    {
      field: "street",
      headerName: "Area / Town / Locality",
      width: 200,
      check_status: true,
    },
    {
      field: "city",
      headerName: "City",
      width: 160,
      check_status: true,
    },
    {
      field: "state",
      headerName: "State",
      width: 160,
      check_status: true,
    },
    {
      field: "pincode",
      headerName: "Pincode",
      width: 130,
      check_status: true,
    },
    {
      field: "country",
      headerName: "Country",
      width: 160,
      check_status: true,
    },
    // {
    //   field: "policy_id",
    //   headerName: "Policy ID",
    //   width: 150,
    //   check_status: true,
    // },
    {
      field: "nop",
      headerName: "Number of policies",
      width: 150,
      check_status: true,
    },
    // {
    //   field: "policies",
    //   headerName: "Policy Type",
    //   width: 150,
    //   check_status: true,
    // },
    // {
    //   field: "insurer",
    //   headerName: "Insurer",
    //   width: 150,
    //   check_status: true,
    // },
    // {
    //   field: "sum_insured",
    //   headerName: "Sum Insured / Assured",
    //   width: 160,
    //   check_status: true,
    // },
    {
      field: "branch_location",
      headerName: "Branch Location",
      width: 200,
      check_status: true,
    },
  ]);

  const rows = [
    {
      id: 0,
      member_type: "Dependant",
      employee_id: "DV007",
      title: "Mr.",
      fullName: "Umesh",
      last_name: "Gemini",
      org_employee: "",
      relationship_emp: "Wife",
      related_emp: "EV0007-Pooja Gemini",
      gender: "Male",
      dob: "12-01-1995",
      doj: "12-01-2022",
      designation: "",
      salary: "",
      salary_bracket: "",
      department: "",
      status: "Active",
      dependents: "Yes",
      nod: "515",
      sum_insured: "2L, 3L, 5L",
      policies: "Group Health Policy",
      insurer: "HDFC ERGO",
      nop: "4",
      client_name: "Evervent",
      client_id: "EV234",
      policy_id: "VJHGJ324234",
      company_email: "",
      personal_email: "umesh@gmail.com",
      mobile: "+91-0000000000",
      hno: "204 P",
      street: "Phase 9 Industrial Area",
      city: "Mohali",
      state: "Punjab",
      pincode: "160062",
      country: "India",
      branch_location: "",
    },
    {
      id: 1,
      member_type: "Employee",
      employee_id: "EV007",
      title: "Mrs.",
      fullName: "Pooja",
      last_name: "Gemini",
      org_employee: "ABC",
      relationship_emp: "Self",
      related_emp: "EV0007-Pooja Gemini",
      gender: "Female",
      dob: "12-01-1995",
      doj: "12-01-2022",
      designation: "Software Engineer",
      department: "Engineering",
      salary: "₹ 6,00,000",
      salary_bracket: "₹ 5,00,000 - ₹10,00,000",
      status: "Inprogress",
      dependents: "No",
      nod: "0",
      sum_insured: "2L, 3L, 5L",
      policies: "Group Term Policy",
      insurer: "Bajaj Allianz",
      nop: "4",
      client_name: "Evervent",
      client_id: "EV234",
      policy_id: "VJHGJ324234",
      company_email: "Pooja.gemini@evervent.in",
      personal_email: "Pooja@gmail.com",
      mobile: "+91-0000000000",
      hno: "204 P",
      street: "Phase 9 Industrial Area",
      city: "Mohali",
      state: "Punjab",
      pincode: "160062",
      country: "India",
      branch_location: "Delhi",
    },
    {
      id: 2,
      member_type: "Employee",
      employee_id: "EV007",
      title: "Mr.",
      fullName: "Umesh",
      last_name: "Gemini",
      org_employee: "ABC",
      relationship_emp: "Self",
      related_emp: "EV0007-Umesh Gemini",
      gender: "Male",
      dob: "12-01-1995",
      doj: "12-01-2022",
      designation: "Software Engineer",
      department: "Engineering",
      salary: "₹ 6,00,000",
      salary_bracket: "₹ 5,00,000 - ₹10,00,000",
      status: "Active",
      dependents: "Yes",
      nod: "451",
      sum_insured: "2L, 3L, 5L",
      policies: "Group Health Policy",
      insurer: "HDFC ERGO",
      nop: "4",
      client_name: "Evervent",
      client_id: "EV234",
      policy_id: "VJHGJ324234",
      company_email: "umesh.gemini@evervent.in",
      personal_email: "umesh@gmail.com",
      mobile: "+91-0000000000",
      hno: "204 P",
      street: "Phase 9 Industrial Area",
      city: "Mohali",
      state: "Punjab",
      pincode: "160062",
      country: "India",
      branch_location: "Chandigarh",
    },
    {
      id: 3,
      member_type: "Dependant",
      employee_id: "DV007",
      title: "Ms.",
      fullName: "Jasmine",
      last_name: "Gemini",
      org_employee: "",
      relationship_emp: "Daughter",
      related_emp: "EV0007-Pooja Gemini",
      gender: "Female",
      dob: "12-01-1995",
      doj: "12-01-2022",
      designation: "",
      department: "",
      salary: "",
      salary_bracket: "",
      status: "Inprogress",
      dependents: "Yes",
      nod: "651",
      sum_insured: "2L, 3L, 5L",
      policies: "Group Term Policy",
      insurer: "Bajaj Allianz",
      nop: "4",
      client_name: "Evervent",
      client_id: "EV234",
      policy_id: "VJHGJ324234",
      company_email: "",
      personal_email: "Jasmine@gmail.com",
      mobile: "+91-0000000000",
      hno: "204 P",
      street: "Phase 9 Industrial Area",
      city: "Mohali",
      state: "Punjab",
      pincode: "160062",
      country: "India",
      branch_location: "",
    },
    {
      id: 4,
      member_type: "Employee",
      employee_id: "EV007",
      title: "Mr.",
      fullName: "Umesh",
      last_name: "Gemini",
      org_employee: "ABC",
      relationship_emp: "Self",
      related_emp: "EV0007-Umesh Gemini",
      gender: "Male",
      dob: "12-01-1995",
      doj: "12-01-2022",
      designation: "Software Engineer",
      department: "Engineering",
      salary: "₹ 6,00,000",
      salary_bracket: "₹ 5,00,000 - ₹10,00,000",
      status: "Active",
      dependents: "No",
      nod: "0",
      sum_insured: "2L, 3L, 5L",
      policies: "Group Health Policy",
      insurer: "HDFC ERGO",
      nop: "4",
      client_name: "Evervent",
      client_id: "EV234",
      policy_id: "VJHGJ324234",
      company_email: "umesh.gemini@evervent.in",
      personal_email: "umesh@gmail.com",
      mobile: "+91-0000000000",
      hno: "204 P",
      street: "Phase 9 Industrial Area",
      city: "Mohali",
      state: "Punjab",
      pincode: "160062",
      country: "India",
      branch_location: "Chennai",
    },
    {
      id: 5,
      member_type: "Dependant",
      employee_id: "DV007",
      title: "Mrs.",
      fullName: "Jasmine",
      last_name: "Gemini",
      org_employee: "",
      relationship_emp: "Daughter",
      related_emp: "EV0007-Pooja Gemini",
      gender: "Female",
      dob: "12-01-1995",
      doj: "12-01-2022",
      designation: "",
      department: "",
      salary: "",
      salary_bracket: "",
      status: "Rejected",
      dependents: "No",
      nod: "0",
      sum_insured: "2L, 3L, 5L",
      policies: "Group Term Policy",
      insurer: "Bajaj Allianz",
      nop: "4",
      client_name: "Evervent",
      client_id: "EV234",
      policy_id: "VJHGJ324234",
      company_email: "",
      personal_email: "Jasmine@gmail.com",
      mobile: "+91-0000000000",
      hno: "204 P",
      street: "Phase 9 Industrial Area",
      city: "Mohali",
      state: "Punjab",
      pincode: "160062",
      country: "India",
      branch_location: "",
    },
    {
      id: 6,
      member_type: "Employee",
      employee_id: "EV007",
      title: "Ms.",
      fullName: "Pooja",
      last_name: "Gemini",
      org_employee: "ABC",
      relationship_emp: "Self",
      related_emp: "EV0007-Umesh Gemini",
      gender: "Female",
      dob: "12-01-1995",
      doj: "12-01-2022",
      designation: "Software Engineer",
      department: "Engineering",
      salary: "₹ 6,00,000",
      salary_bracket: "₹ 5,00,000 - ₹10,00,000",
      status: "Active",
      dependents: "Yes",
      nod: "542",
      sum_insured: "2L, 3L, 5L",
      policies: "Group Health Policy",
      insurer: "HDFC ERGO",
      nop: "4",
      client_name: "Evervent",
      client_id: "EV234",
      policy_id: "VJHGJ324234",
      company_email: "Pooja.gemini@evervent.in",
      personal_email: "Pooja@gmail.com",
      mobile: "+91-0000000000",
      hno: "204 P",
      street: "Phase 9 Industrial Area",
      city: "Mohali",
      state: "Punjab",
      pincode: "160062",
      country: "India",
      branch_location: "Chandigarh",
    },
    {
      id: 7,
      member_type: "Dependant",
      employee_id: "DV007",
      title: "Mrs.",
      fullName: "Pooja",
      last_name: "Gemini",
      org_employee: "",
      relationship_emp: "Wife",
      related_emp: "EV0007-Umesh Gemini",
      gender: "Female",
      dob: "12-01-1995",
      doj: "12-01-2022",
      designation: "",
      department: "",
      salary: "",
      salary_bracket: "",
      status: "Inprogress",
      dependents: "Yes",
      nod: "325",
      sum_insured: "2L, 3L, 5L",
      policies: "Group Term Policy",
      insurer: "Bajaj Allianz",
      nop: "4",
      client_name: "Evervent",
      client_id: "EV234",
      policy_id: "VJHGJ324234",
      company_email: "",
      personal_email: "Pooja@gmail.com",
      mobile: "+91-0000000000",
      hno: "204 P",
      street: "Phase 9 Industrial Area",
      city: "Mohali",
      state: "Punjab",
      pincode: "160062",
      country: "India",
      branch_location: "",
    },
    {
      id: 8,
      member_type: "Employee",
      employee_id: "EV007",
      title: "Mrs.",
      fullName: "Vaishali",
      last_name: "Rana",
      org_employee: "ABC",
      relationship_emp: "Self",
      related_emp: "EV0007-Suveshi Sharma",
      gender: "Female",
      dob: "14-12-1997",
      doj: "08-09-2021",
      designation: "Assistant Manager",
      department: "HR",
      salary: "₹ 6,00,000",
      salary_bracket: "₹ 5,00,000 - ₹10,00,000",
      status: "Rejected",
      dependents: "No",
      nod: "0",
      sum_insured: "2L, 3L, 5L",
      policies: "Group Health Policy",
      insurer: "HDFC ERGO",
      nop: "4",
      client_name: "Evervent",
      client_id: "EV39",
      policy_id: "VJHGJ324234",
      company_email: "vaishali.rana@evervent.in",
      personal_email: "vaishali@gmail.com",
      mobile: "+91-0000000000",
      hno: "900",
      street: "Homeland",
      city: "Mohali",
      state: "Punjab",
      pincode: "160062",
      country: "India",
      branch_location: "Delhi",
    },
    {
      id: 9,
      member_type: "Dependant",
      employee_id: "DV007",
      title: "Ms.",
      fullName: "Mohit",
      last_name: "Gemini",
      org_employee: "",
      relationship_emp: "Son",
      related_emp: "EV0007-Umesh Gemini",
      gender: "Male",
      dob: "12-01-1995",
      doj: "12-01-2022",
      designation: "",
      department: "",
      salary: "",
      salary_bracket: "",
      status: "Active",
      dependents: "Yes",
      nod: "545",
      sum_insured: "2L, 3L, 5L",
      policies: "Group Term Policy",
      insurer: "Bajaj Allianz",
      nop: "4",
      client_name: "Evervent",
      client_id: "EV234",
      policy_id: "VJHGJ324234",
      company_email: "",
      personal_email: "mohit@gmail.com",
      mobile: "+91-0000000000",
      hno: "204 P",
      street: "Phase 9 Industrial Area",
      city: "Mohali",
      state: "Punjab",
      pincode: "160062",
      country: "India",
      branch_location: "",
    },
    {
      id: 10,
      member_type: "Employee",
      employee_id: "EV007",
      title: "Mr.",
      fullName: "Umesh",
      last_name: "Gemini",
      org_employee: "ABC",
      relationship_emp: "Wife",
      gender: "Male",
      dob: "12-01-1995",
      doj: "12-01-2022",
      designation: "Software Engineer",
      department: "Engineering",
      salary: "₹ 6,00,000",
      salary_bracket: "₹ 5,00,000 - ₹10,00,000",
      status: "Inprogress",
      dependents: "No",
      nod: "0",
      sum_insured: "2L, 3L, 5L",
      policies: "Group Health Policy",
      insurer: "HDFC ERGO",
      nop: "4",
      client_name: "Evervent",
      client_id: "EV234",
      policy_id: "VJHGJ324234",
      company_email: "umesh.gemini@evervent.in",
      personal_email: "umesh@gmail.com",
      mobile: "+91-0000000000",
      hno: "204 P",
      street: "Phase 9 Industrial Area",
      city: "Mohali",
      state: "Punjab",
      pincode: "160062",
      country: "India",
      branch_location: "Dehradun",
    },
    {
      id: 11,
      member_type: "Dependant",
      employee_id: "DV007",
      title: "Mrs.",
      fullName: "Jasmine",
      last_name: "Gemini",
      org_employee: "",
      relationship_emp: "Wife",
      gender: "Female",
      dob: "12-01-1995",
      doj: "12-01-2022",
      designation: "",
      department: "",
      salary: "",
      salary_bracket: "",
      status: "Active",
      dependents: "Yes",
      nod: "412",
      sum_insured: "2L, 3L, 5L",
      policies: "Group Health Policy",
      insurer: "HDFC ERGO",
      nop: "4",
      client_name: "Evervent",
      client_id: "EV234",
      policy_id: "VJHGJ324234",
      company_email: "",
      personal_email: "Jasmine@gmail.com",
      mobile: "+91-0000000000",
      hno: "204 P",
      street: "Phase 9 Industrial Area",
      city: "Mohali",
      state: "Punjab",
      pincode: "160062",
      country: "India",
      branch_location: "",
    },
  ];

  const updateMasterState = (attrName: any, value: any) => {
    attrName(value);
  };
  return (
    <Grid container spacing={2}>
      <AddNewEmployee
        attrName={setAddNewEmployee}
        open_status={addNewEmployee}
        value_update={updateMasterState}
      />
      <BulkUploadForm
        open_status={uploadFile}
        attrName={setUploadFile}
        value_update={updateMasterState}
      />
      <Modal open={removeEmployee} className="modalWrapper">
        <Box className="modalInner lg-width">
          <Grid container spacing={2}>
            <Grid xs={12}>
              <Link
                className="close-button"
                onClick={() => {
                  setRemoveEmployee(false);
                }}
              />
              <h5 className="popup-heading">Are you sure ?</h5>
            </Grid>
          </Grid>
          <Grid container spacing={2} textAlign="center">
            <Grid xs={12}>
              <Link className="md-link" underline="none">
                You are about to remove 5 Employees
              </Link>
            </Grid>
            <Grid xs={12} style={{ textAlign: "center" }} className="ctaBtn">
              <Button
                variant="contained"
                className="submitBtn"
                onClick={() => {
                  setRemoveEmployee(false);
                }}
              >
                Yes, Remove
              </Button>
            </Grid>
          </Grid>
        </Box>
      </Modal>
      {/* filter popup */}
      <Modal open={addFilterStatus} className="modalWrapper">
        <Box className="modalInner">
          <Grid container spacing={1}>
            <Grid xs={12}>
              <Link
                className="close-button"
                onClick={() => {
                  setAddFilterStatus(false);
                }}
              />
              <h5 className="popup-heading">Add Filters</h5>
            </Grid>
          </Grid>
          <Grid container spacing={2}>
            <Grid xs={6}>
              <FormControl fullWidth>
                <InputLabel id="demo-simple-select-label">Client ID</InputLabel>
                <Select
                  labelId="demo-simple-select-label"
                  id="demo-simple-select"
                  value={age}
                  label="Client ID"
                  onChange={(e) => handleChange(e, "age")}
                >
                  <MenuItem value={"20"}>20 years</MenuItem>
                  <MenuItem value={"22"}>22 years</MenuItem>
                  <MenuItem value={"24"}>24 years</MenuItem>
                </Select>
              </FormControl>
            </Grid>
            <Grid xs={6}>
              <FormControl fullWidth>
                <InputLabel id="demo-simple-select-label">
                  Policy Status
                </InputLabel>
                <Select
                  labelId="demo-simple-select-label"
                  id="demo-simple-select"
                  value={age}
                  label="Policy Status"
                  onChange={(e) => handleChange(e, "age")}
                >
                  <MenuItem value={"20"}>20 years</MenuItem>
                  <MenuItem value={"22"}>22 years</MenuItem>
                  <MenuItem value={"24"}>24 years</MenuItem>
                </Select>
              </FormControl>
            </Grid>
            <Grid xs={12}>
              <TextField
                fullWidth
                id="outlined-basic"
                label="Client Name"
                variant="outlined"
                className="textarea"
              />
            </Grid>
            <Grid xs={6}>
              <FormControl fullWidth>
                <InputLabel id="demo-simple-select-label">Status</InputLabel>
                <Select
                  labelId="demo-simple-select-label"
                  id="demo-simple-select"
                  value={age}
                  label="Designation"
                  onChange={(e) => handleChange(e, "age")}
                >
                  <MenuItem value={"20"}>20 years</MenuItem>
                  <MenuItem value={"22"}>22 years</MenuItem>
                  <MenuItem value={"24"}>24 years</MenuItem>
                </Select>
              </FormControl>
            </Grid>
            <Grid xs={6}>
              <FormControl fullWidth>
                <InputLabel id="demo-simple-select-label">Status</InputLabel>
                <Select
                  labelId="demo-simple-select-label"
                  id="demo-simple-select"
                  value={age}
                  label="Status"
                  onChange={(e) => handleChange(e, "age")}
                >
                  <MenuItem value={"20"}>20 years</MenuItem>
                  <MenuItem value={"22"}>22 years</MenuItem>
                  <MenuItem value={"24"}>24 years</MenuItem>
                </Select>
              </FormControl>
            </Grid>

            <Grid xs={12} style={{ textAlign: "center" }} className="ctaBtn">
              <Button
                variant="contained"
                className="submitBtn"
                onClick={() => {
                  setAddFilterStatus(false);
                }}
              >
                Apply
              </Button>
            </Grid>
          </Grid>
        </Box>
      </Modal>
      {/* Invite Employees Popup */}
      <Modal open={InviteEmployee} className="modalWrapper">
        <Box className="modalInner">
          <Grid container spacing={2}>
            <Grid xs={12}>
              <Link
                className="close-button"
                onClick={() => {
                  setInviteEmployee(false);
                }}
              />
              <h5 className="popup-heading">Invite Employees</h5>
            </Grid>
          </Grid>
          <Grid container spacing={2} textAlign="center" className="mb-4">
            <Grid xs={12}>
              <RKTextField
                class_name="inputField"
                title="Email Address"
                value={emailAddress}
                value_update={updateMasterState}
                attrName={setEmailAddress}
                warn_status={false}
              />
            </Grid>
          </Grid>
          <Grid container spacing={2}>
            <Grid xs={12} style={{ textAlign: "center" }} className="ctaBtn">
              <Button
                variant="contained"
                className="submitBtn"
                onClick={() => {
                  setInviteEmployee(false);
                }}
              >
                Invite
              </Button>
            </Grid>
          </Grid>
        </Box>
      </Modal>
      <Modal open={addPolicyStatus} className="modalWrapper">
        <Box className="modalInner">
          <Grid container spacing={1}>
            <Grid xs={12}>
              <Link
                className="close-button"
                onClick={() => {
                  setAddPolicyStatus(false);
                }}
              />
              <h5 className="popup-heading">Kudos !!</h5>
            </Grid>
          </Grid>
          <Grid container spacing={0} textAlign="center">
            <Grid xs={12} className="mb-5">
              <h1>Img</h1>
            </Grid>
            <Grid xs={12} className="mb-5">
              <h5 className="popup-heading">
                Invitation has been sent successfully
              </h5>
            </Grid>
          </Grid>
        </Box>
      </Modal>

      <Grid xs={6} style={{ display: "flex", alignItems: "center" }}>
        <h3 className="mb-0 mr-3">Members</h3>
        <SearchBox />
      </Grid>
      <Grid xs={6} className="text-right">
        <UGDateRangePicker
          minDate={new Date()}
          maxDate={new Date()}
          placement="bottom"
        />
        <Link
          underline="none"
          className="blueBtn mail"
          onClick={() => {
            setInviteEmployee(true);
          }}
        >
          Invite Employees
        </Link>
        <Link
          underline="none"
          className="blueBtn upload"
          onClick={() => {
            navigate(ALL_ROUTES.BULK_UPLOAD_PAGE);
          }}
        >
          Bulk Upload
        </Link>
        <Link
          underline="none"
          className="greenBtn addfile"
          onClick={() => {
            navigate("../AddNewEmployee");
          }}
        >
          Add
        </Link>
        <Link
          underline="none"
          className="redBtn delete"
          onClick={() => {
            setRemoveEmployee(true);
          }}
        >
          Remove
        </Link>
      </Grid>
      <Grid xs={12}>
        <UGTable
          header_data={columns}
          data={rows}
          value_update={updateMasterState}
          attrName={"UGTable"}
        />
      </Grid>
    </Grid>
  );
};

export default Employees;
